export const sendMail =  () => {
  try {
    // Ensure Office is ready
    // Confirm we are in compose mode
    const item = Office.context.mailbox.item;
 
    // Check support for programmatic send (Mailbox 1.15)
    const canProgrammaticallySend =
      !!Office.context.requirements &&
      Office.context.requirements.isSetSupported &&
      Office.context.requirements.isSetSupported("Mailbox", "1.15");

    // Add To recipients (compose mode)
    if (canProgrammaticallySend && item?.sendAsync) {
      // send programmatically
      item.sendAsync((sendResult) => {
        if (sendResult.status === Office.AsyncResultStatus.Succeeded) {
          console.log("Message sent successfully.");
        } else {
          console.error("sendAsync failed:", sendResult.error);
          // optional: fallback to Graph or show UI to user
        }
      });
    } else {
      // Fallback: notify user they must press Send or implement Graph send
      console.warn(
        "Programmatic send not supported in this client. Consider using Microsoft Graph fallback or instruct the user to press Send."
      );
      // Optionally save draft: item.saveAsync(...)
    }
  } catch (err) {
    console.error("Unexpected error in handleSend:", err);
  }
};
